'use client';

import { useState } from 'react';

import { Play } from 'lucide-react';
import YouTube from 'react-youtube';

import { Button } from '~/components/ui/button';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '~/components/ui/dialog';

interface YouTubeVideoButtonProps {
  buttonText?: string;
  youTubeId: string;
  className?: string;
}

export function YouTubeVideoButton({ youTubeId, buttonText = 'Watch Video', className }: YouTubeVideoButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className={className} asChild>
        <Button variant='link' className='text-blue'>
          <Play className='size-4 fill-current' />
          {buttonText}
        </Button>
      </DialogTrigger>
      <DialogContent className=' bg-black p-0 sm:max-w-6xl'>
        <DialogTitle className='sr-only'>Video</DialogTitle>
        <YouTube
          className='animate-out fade-out-100 fill-mode-forwards relative h-0 max-h-[90svh] w-full overflow-hidden rounded-2xl pb-[56.25%] opacity-0 delay-500 duration-1000'
          iframeClassName='size-full absolute inset-0'
          videoId={youTubeId}
          onEnd={() => setOpen(false)}
          opts={{
            playerVars: {
              autoplay: 1,
              playsinline: 1,
            },
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
